// Komal Code
import React, { useEffect, useState, useRef } from "react";
import { Button, DateBox, SelectBox } from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import { Item } from "devextreme-react/toolbar";
import BreadCrumb from "../../components/breadCrumb/BreadCrumb";
import CustomDropdown from "../../components/customDropDown/CustomDropdown";
import {
  HeaderText,
  SubText,
} from "../../components/typographyText/TypographyText";
import { statusDataSource } from "../tickets/data";
import "./ReportsPage.scss";
import { useNavigate } from "react-router-dom";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { LoadPanel } from "devextreme-react";
import { useAuth } from "../../contexts/auth";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { getReportApi } from "../../api/reportsApi";
import ExcelJS from "exceljs";
import { getTicketsApi } from "../../api/ticketApi";
import { formatDate } from "devextreme/localization";
import { filterTicketsApi } from "../../api/filterAPI";
import { fetchCustomerData } from "../../api/companyCustomerApi";
import { fetchUsers } from "../../api/companyUserApi";
import { getAllStatus } from "../../api/settingsApi";

export default function ReportsPage() {
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const ticketdataGridRef = useRef(null);
  const [filteredData, setFilteredData] = useState([]);
  const [userDataSource, setUserDataSource] = useState([
    { value: "All Developer", text: "All Developer" },
  ]);
  const [customerDataSource, setcustomerDataSource] = useState([
    { value: "All Client", text: "All Client" },
  ]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState("All Client");
  const [selectedUser, setSelectedUser] = useState("0");
  const [selectedStatus, setSelectedStatus] = useState("All Status");
  const [displayedTicketCount, setDisplayedTicketCount] = useState(0);

  const updateDisplayedTicketCount = () => {
    if (ticketdataGridRef.current?.instance) {
      const totalCount = ticketdataGridRef.current.instance.totalCount();
      setDisplayedTicketCount(totalCount || 0);
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);

  const totalPages = Math.ceil(totalCount / pageSize);

  const fetchTickets = async (page = pageIndex) => {
    try {
      setLoading(true);

      const offset = page * pageSize;

      const ticketResult = await getTicketsApi(offset);

      if (ticketResult.status !== 200) {
        throw new Error("Error fetching tickets");
      }

      const apiData = ticketResult.data || [];

      const formattedData = apiData.map((ticket) => {
        if (ticket.entry_date) {
          const dateObj = new Date(ticket.entry_date);
          ticket.entry_date = `${dateObj
            .getDate()
            .toString()
            .padStart(2, "0")}/${(dateObj.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${dateObj.getFullYear()} ${
            dateObj.toTimeString().split(" ")[0]
          }`;
        }

        return ticket;
      });

      setReportData(formattedData);
      setFilteredData(formattedData);

      // (same as Ticket page)
      const total = apiData.length > 0 ? apiData[0].total_count : 0;
      setTotalCount(total);
    } catch (error) {
      ToastDisplayer("error", "Error fetching ticket data");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTickets(pageIndex);
  }, [pageIndex]);

  // const nextPageTemplate = (data) => {
  //   const handleButtonClick = () => {
  //     navigate("/ticket/Details-of-Ticket");
  //   };
  const nextPageTemplate = (data) => {
    const handleButtonClick = () => {
      navigate("/ticket/Details-of-Ticket", {
        state: { detailData: data.data, from: "Reports" },
      });
    };

    return (
      <div className="nextPageBtn">
        <i className="ri-arrow-right-up-line" onClick={handleButtonClick}></i>
      </div>
    );
  };

  const handleDateFilter = () => {
    if (!fromDate || !toDate) {
      return; // Do nothing if dates are not selected
    }

    const from = new Date(fromDate);
    const to = new Date(toDate);
    to.setHours(23, 59, 59, 999); // Set `to` to the end of the day

    if (to <= from) {
      ToastDisplayer(
        "error",
        'The "To Date" must be greater than the "From Date".',
      );
      return;
    }

    const filtered = reportData.filter((ticket) => {
      const entryDate = new Date(
        ticket.entry_date.split(" ")[0].split("/").reverse().join("-"),
      );
      return entryDate >= from && entryDate <= to;
    });

    setFilteredData(filtered);
  };

  // const handleModifyFilter = () => {
  //   if (!selectedUser || !selectedCustomer) {
  //     ToastDisplayer("error", "Please select filters before applying.");
  //     return;
  //   } else {
  //     handleDateFilter();
  //     handleStatusChange(selectedStatus);
  //     handleWorkingUser(selectedUser);
  //     handleWorkingcustomer(selectedCustomer);
  //   }
  // };

  const handleReset = () => {
    if (isFilterApplied) {
      setFromDate(null);
      setToDate(null);
      setSelectedCustomer("All Client");
      setSelectedUser("0");
      setSelectedStatus("All Status");
      setIsFilterMode(false);
      setPageIndex(0);
      fetchTickets(0);
    }
  };

  const handleStatusChange = (newFilter) => {
    setSelectedStatus(newFilter);

    const statusFilter =
      newFilter === "All Status" ? null : newFilter.toLowerCase();

    const filtered = reportData.filter((ticket) => {
      const statusMatch =
        !statusFilter || ticket.ticketstatus?.toLowerCase() === statusFilter;

      const userMatch =
        selectedUser === "All Developer" ||
        ticket?.assigned_developer?.developer_name === selectedUser;
      const customerMatch =
        selectedCustomer === "All Client" ||
        ticket.customer_name === selectedCustomer;
      const dateMatch =
        !fromDate ||
        !toDate ||
        (new Date(
          ticket.entry_date.split(" ")[0].split("/").reverse().join("-"),
        ) >= new Date(fromDate) &&
          new Date(
            ticket.entry_date.split(" ")[0].split("/").reverse().join("-"),
          ) <= new Date(toDate).setHours(23, 59, 59, 999));

      return statusMatch && userMatch && customerMatch && dateMatch;
    });

    setFilteredData(filtered);
  };

  const handleWorkingUser = (newFilter) => {
    const filterValue = newFilter === "All Developer" ? null : newFilter;
    if (ticketdataGridRef.current && ticketdataGridRef.current.instance) {
      ticketdataGridRef.current.instance.columnOption(
        "WORKING DEVELOPER",
        "filterValue",
        filterValue,
      );
      ticketdataGridRef.current.instance.refresh();
    }
  };

  const handleWorkingcustomer = (newFilter) => {
    const filterValue = newFilter === "All Client" ? null : newFilter;
    if (ticketdataGridRef.current && ticketdataGridRef.current.instance) {
      ticketdataGridRef.current.instance.columnOption(
        "CUSTOMER",
        "filterValue",
        filterValue,
      );
      ticketdataGridRef.current.instance.refresh();
    }
  };

  // export functionality for custom  Export Button
  const handleExport = () => {
    const grid = ticketdataGridRef.current?.instance;
    if (!grid) return;

    const selectedKeys = grid.getSelectedRowKeys();

    if (selectedKeys.length > 0) {
      grid.exportToExcel(true); // selected rows
    } else {
      grid.exportToExcel(false); // fallback → all rows
    }
  };

  // Exporting data into excel
  const onExporting = (e) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tickets");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      const formatDate = (date) => {
        if (!date) return "All";
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      };

      const from = formatDate(fromDate);
      const to = formatDate(toDate);

      const fileName = `Reports_${from}_to_${to}.xlsx`;

      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          fileName,
        );
      });
    });

    e.cancel = true;
  };
  const [isFilterMode, setIsFilterMode] = useState(false);

  const formatDateForAPI = (date) => {
    if (!date) return null;

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const handleModifyFilter = async () => {
    try {
      setLoading(true);

      const params = {};

      // DATE FILTER
      if (fromDate) {
        params.from_date = formatDateForAPI(fromDate);
      }

      if (toDate) {
        params.to_date = formatDateForAPI(toDate);
      }

      // STATUS
      if (selectedStatus !== "All Status") {
        params.status = selectedStatus;
      }

      // USER
      if (selectedUser !== "0") {
        params.assigned_user = selectedUser;
      }

      // CUSTOMER
      if (selectedCustomer !== "All Client") {
        params.customer_id = selectedCustomer;
      }

      const res = await filterTicketsApi(params);

      if (res.success) {
        const tickets = res.data?.tickets || [];

        const formattedData = tickets.map((ticket) => {
          if (ticket.entry_date) {
            const dateObj = new Date(ticket.entry_date);
            ticket.entry_date = `${dateObj
              .getDate()
              .toString()
              .padStart(2, "0")}/${(dateObj.getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${dateObj.getFullYear()} ${
              dateObj.toTimeString().split(" ")[0]
            }`;
          }
          return ticket;
        });

        setFilteredData(formattedData);
        setTotalCount(res.data.count || formattedData.length);
        setPageIndex(0);
        setIsFilterMode(true);
      }
    } catch (error) {
      ToastDisplayer("error", "Filter failed");
    } finally {
      setLoading(false);
    }
  };
  const isFilterApplied =
    fromDate ||
    toDate ||
    selectedCustomer !== "All Client" ||
    selectedUser !== "0" ||
    selectedStatus !== "All Status";

  const [customerList, setCustomerList] = useState();
  const [custOptions, setCustOptions] = useState([
    { value: "0", text: "All Client" },
  ]);

  const loadCustomerData = async () => {
    try {
      setLoading(true);

      const res = await fetchCustomerData(user?.companytransid);

      const formattedCustomers = [
        { value: "All Client", text: "All Client" },
        ...res.data?.map((cust) => ({
          value: cust.transid,
          text: cust.custname,
        })),
      ];

      setCustOptions(formattedCustomers);
    } catch (err) {
      ToastDisplayer("error", "Failed to load customers");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCustomerData();
  }, []);

  const [agentOptions, setAgentOptions] = useState([
    { value: "0", text: "All Developer" },
  ]);
  const loadAgents = async () => {
    try {
      const res = await fetchUsers(user?.companytransid);

      if (res?.data) {
        const agents = res.data.map((u) => ({
          value: u.transid.toString(),
          text: u.cmpuserusername,
        }));

        setAgentOptions([{ value: "0", text: "All Developer" }, ...agents]);
      }
    } catch (error) {
      ToastDisplayer("error", "Failed to load agents");
    }
  };

  useEffect(() => {
    if (user?.companytransid) {
      loadAgents();
    }
  }, [user]);

  const [statusList, setStatusList] = useState([]);

  const fetchStatusList = async () => {
    try {
      const res = await getAllStatus();

      const formatted = [
        { text: "All Status", value: "All Status" }, // ✅ ADD THIS
        ...res.map((item) => ({
          text: item.name,
          value: item.id.toString(),
          color: item.color_code,
          roles: item.allowed_roles,
        })),
      ];

      setStatusList(formatted);
    } catch (error) {
      console.error("Failed to fetch status list", error);
    }
  };
  useEffect(() => {
    fetchStatusList();
  }, []);

  return (
    <>
      {loading && <LoadPanel visible={loading} />}
      <div className="wholePage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-file-chart-line"></i>
              </span>
              <p>Reports</p>
            </div>
            <div className="totalTicketTitle">
              <SubText
                text={`Select a date range and filters to view the data.`}
              />
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Export"
              icon="export"
              stylingMode="outlined"
              type="default"
              width={120}
              onClick={handleExport}
            />
          </div>
        </div>
        <div className="reportsMain">
          <div className="topSection">
            <div className="MyTextBox">
              <label className="TextBoxLabel">
                From Date <span className="requiredClass">*</span>
              </label>
              <div className="TextBoxWrapper">
                <DateBox
                  placeholder="Select Date"
                  inputAttr={{ "aria-label": "Date" }}
                  type="date"
                  className="TextBoxMain"
                  width={"100%"}
                  stylingMode="outlined"
                  pickerType="calendar"
                  displayFormat="dd-MM-yyyy"
                  value={fromDate}
                  onValueChanged={(e) => setFromDate(e.value)}
                />
              </div>
            </div>
            <div className="MyTextBox">
              <label className="TextBoxLabel">
                To Date <span className="requiredClass">*</span>
              </label>
              <div className="TextBoxWrapper">
                <DateBox
                  placeholder="Select Date"
                  inputAttr={{ "aria-label": "Date" }}
                  type="date"
                  className="TextBoxMain"
                  width={"100%"}
                  stylingMode="outlined"
                  displayFormat="dd-MM-yyyy"
                  pickerType="calendar"
                  value={toDate}
                  onValueChanged={(e) => setToDate(e.value)}
                />
              </div>
            </div>
            <div className="MySelectBox">
              {/* <CustomDropdown
                label={"Customer"}
                myDataSource={customerDataSource}
                placeholder={"Select Customer"}
                value={selectedCustomer}
                setSelectedValue={(e) => {
                  setSelectedCustomer(e?.value);
                }}
              /> */}
              <label>
                Clients <span className="requiredClass">*</span>
              </label>
              <SelectBox
                height={48}
                items={custOptions} // ✅ use custOptions
                valueExpr="value"
                displayExpr="text"
                value={selectedCustomer}
                stylingMode="outlined"
                searchEnabled={true}
                placeholder="Select Client"
                width="100%"
                onValueChanged={(e) => {
                  setSelectedCustomer(e.value);
                }}
              />
            </div>
            <div className="MySelectBox">
              {/* <CustomDropdown
                label={"User"}
                myDataSource={userDataSource}
                placeholder={"Select User"}
                value={selectedUser}
                setSelectedValue={(e) => {
                  setSelectedUser(e?.value); // Store selected user value
                }}
              /> */}
              <label>
                Developers <span className="requiredClass">*</span>
              </label>
              <SelectBox
                height={48}
                items={agentOptions}
                valueExpr="value" //id
                displayExpr="text" //name
                value={selectedUser}
                stylingMode="outlined"
                searchEnabled={true}
                placeholder="Select Developer"
                width="100%"
                onValueChanged={(e) => {
                  setSelectedUser(e.value);
                }}
              />
            </div>
            <div className="MySelectBox">
              <label>
                Status <span className="requiredClass">*</span>
              </label>
              <SelectBox
                height={48}
                width="100%"
                placeholder="Select Status"
                className="selectboxStatus custom-status-dropdown"
                valueExpr="value"
                displayExpr="text"
                stylingMode="outlined"
                items={statusList}
                value={selectedStatus}
                // defaultValue={"All Status"}
                onValueChanged={(e) => setSelectedStatus(e.value)}
                dropDownOptions={{
                  hideOnOutsideClick: true, // ✅ FIX
                }}
              />
            </div>
            <div className="modifyBtnContainer">
              <Button
                text="Filter"
                // className="filterBtn"
                onClick={handleModifyFilter}
                stylingMode="outlined"
                disabled={!isFilterApplied}
                className={!isFilterApplied ? "disableBtn" : "filterBtn"}
              />
              <Button
                text="Reset"
                className="filterBtn"
                onClick={handleReset}
                stylingMode="outlined"
              />
            </div>
          </div>

          <div className="botSection" style={{ height: "calc(100vh - 350px)" }}>
            <div className="ReportDatagrid">
              <DataGrid
                keyExpr="ticketcode"
                style={{ height: "calc(100vh - 415px)" }}
                ref={ticketdataGridRef}
                width={"100%"}
                dataSource={filteredData}
                columnAutoWidth={true}
                columnHidingEnabled={true}
                showColumnHeaders={true}
                onContentReady={updateDisplayedTicketCount}
                onExporting={onExporting}
                onOptionChanged={(e) => {
                  if (e.fullName === "paging.pageIndex") {
                    setPageIndex(e.value);
                  }
                }}
              >
                <Export enabled={true} />
                <Toolbar>
                  <Item location="before">
                    <div style={{ fontWeight: "600", fontSize: "18px" }}>
                      <SubText text={`Total ${totalCount} records`} />
                    </div>
                  </Item>
                  <Item location="after" name="searchPanel" />
                  {/* <Item location="after">
                    <SelectBox
                      id="filterStatus"
                      height="44px"
                      width="180px"
                      className="selectboxStatus custom-status-dropdown"
                      valueExpr="value"
                      displayExpr="text"
                      stylingMode="outlined"
                      items={statusList}
                      defaultValue={"All Status"}
                      onValueChanged={(e) => handleStatusChange(e.value)} // Calls the status filtering logic
                    />
                  </Item> */}
                </Toolbar>
                <SearchPanel
                  visible={true}
                  width={window.innerWidth <= 480 ? "80%" : "100%"}
                  placeholder="Search tickets"
                />
                <Selection mode="multiple" showCheckBoxesMode="always" />
                {isFilterMode ? (
                  <>
                    <Paging defaultPageSize={pageSize} />
                    <Pager visible={true} />
                  </>
                ) : (
                  <Paging enabled={false} />
                )}
                <Scrolling mode="standard" />
                <Column
                  dataField="customer_name"
                  caption="CLIENT"
                  cellRender={(data) => (
                    <div className="customer-cell">
                      {data.data.customer_name}
                    </div>
                  )}
                />

                <Column
                  allowSorting={false}
                  allowSearch={false}
                  cellRender={nextPageTemplate}
                />

                <Column
                  dataField="ticketstatus_name"
                  caption="STATUS"
                  cellRender={(data) => (
                    <div
                      className={`status ${data["value"]
                        ?.toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      <span className="col-main" data-type={data["value"]}>
                        <span data-type={data["value"]}>
                          {data["value"] == null ? "-" : data["value"]}
                        </span>
                      </span>
                      {/* <span>{data.ticketstatus_name}</span> */}
                    </div>
                  )}
                />
                <Column dataField="ticketcode" caption="TICKET No." />
                <Column
                  width={200}
                  dataField="ticketsubject"
                  caption="SUBJECT"
                />
                <Column
                  // dataField={filteredData?.assigned_developer}
                  caption="WORKING DEVELOPER"
                  alignment="center"
                  cellRender={(value) => {
                    if (value?.data?.assigned_developer?.developer_name) {
                      return (
                        <div>
                          {value?.data?.assigned_developer?.developer_name}
                        </div>
                      );
                    }
                    return <>--</>;
                  }}
                />
                <Column
                  dataField={"entry_date"}
                  caption="REQUESTED ON"
                  defaultSortOrder="desc"
                />
                <Column
                  alignment={"center"}
                  dataField="total_developer_working_duration"
                  caption="TOTAL WORK HOURS"
                  cellRender={(value) => {
                    if (value?.data?.total_developer_working_duration) {
                      return (
                        <div>
                          {value?.data?.total_developer_working_duration}
                        </div>
                      );
                    }
                    return <>--</>;
                  }}
                />
                <Column dataField="ticketpriority_name" caption="PRIORITY" />
              </DataGrid>
              {!isFilterMode && totalCount > 0 && (
                <div className="customPager">
                  {/* PREVIOUS */}
                  <button
                    className="pager-btn"
                    disabled={pageIndex === 0}
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    <i className="ri-arrow-left-s-line"></i>
                  </button>

                  {/* PAGE NUMBERS */}
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={pageIndex === i ? "activePage" : ""}
                      onClick={() => setPageIndex(i)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  {/* NEXT */}
                  <button
                    className="pager-btn"
                    disabled={pageIndex === totalPages - 1}
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
